import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom'
import { api } from '../../../services/api'
import { photo } from '../../../services/photo';

import { Container } from './styled';
import { Container as ContainerFilter, LoadStyle } from '../Destination2/styled';
import { CarouselItem } from '../../../components/Carousel/Items'
import placeholder from '../../../assets/destino7.png'
import ArrowBack from '../../../components/ArrowBack'

import Button from '../../../components/Button';
import Input from '../../../components/Input';
import StyledSelect from '../../../components/Select';
import Pagination from '../../../components/Pagination'

const Destination3 = () => {

    let location = useLocation()

    const { categoryId, destinationId } = useParams()

    const [ destinations, setDestinations ] = useState([])
    const [photoURL, setPhotoURL] = useState('');

    useEffect(() => {
        api.get(`/destinations/show/${destinationId}`)
        .then((response) => {
            setDestinations(response.data)
            setPhotoURL(
                response.data.images_url ? 
                photo.defaults.baseURL + response.data.images_url[0] :
                placeholder
            )
        })
    }, [destinationId])

    const [ categoryName, setCategoryName ] = useState("")
    const [ hotels, setHotels ] = useState([])
    const [ filteredHotels, setFilteredHotels ] = useState([])
    const [ tags, setTags ] = useState([])
    const [ loading, setLoading ] = useState(true)
    const [ choosenTag, setChoosenTag ] = useState(-1)
    const [ choosenName, setChoosenName ] = useState("")
    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 9;


    const loadHotels = async (pageSize, currentPage, categoryId) => {

        await api.get(`/hotels/index_destination/${destinationId}/${pageSize * (currentPage - 1)}`)
        .then((response) => {
                const temp_hotels = []
                response.data.forEach((hotel) =>{
                    if (hotel.category.id === parseInt(categoryId)){
                        temp_hotels.push(hotel)
                    }
                })
                setHotels(temp_hotels)
                setFilteredHotels(temp_hotels)
            
            setLoading(false)
        })

        .catch(() => {
            return <LoadStyle><h1>Algo de errado aconteceu. Tente novamente!</h1></LoadStyle>
        })

    }

    const loadTags = async () => {

        await api.get('/tags/index')
        
        .then((response) => {
            const options = []
            response.data.forEach((tag)=>{
                options.push({value: tag.id, label: tag.name})
            })
            setTags(options)
        })
    }

    const loadCategory = async (id) => {
        await api.get(`/categories/show/${id}`)
        .then((response) => setCategoryName(response.data.name))
    }

    useEffect(() => {
        loadHotels(pageSize, currentPage, categoryId)
        loadTags()
        loadCategory(categoryId)
    }, [location, pageSize, currentPage, categoryId])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage])

    if (loading) {
        return <LoadStyle>
            <p className='main-text'></p>
            <p className='sub-text'>Aguarde enquanto os hotéis são carregados</p>
        </LoadStyle>
    }

    const handleTagChange = e => {
        try{
            setChoosenTag(e.value)
        } catch {
            setChoosenTag(-1)
        }
    }

    const displayCategory = (categoryName) => {
        if (categoryName === "Praia")
            return "de praia";
        else if (categoryName === "Urbano")
            return "urbanos";
        else if (categoryName === "Rural")
            return "rurais";
        else
            return "";
    }

    const handleNameChange = e => {
        try{
            setChoosenName(e.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase())
        } catch {
            setChoosenName("")
        }
    }

    const isSimilar = (userEntry, dbEntry) => {
        let dbEntryNormalized = dbEntry.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        if (dbEntryNormalized === userEntry || dbEntryNormalized.startsWith(userEntry)){
            return true
        } else{
            let dbArray = dbEntryNormalized.split(" ")
            for (var i = 0; i< dbArray.length; i++){
                if (dbArray[i] === userEntry || dbArray[i].startsWith(userEntry)){
                    return true
                }
            }
            return false
        }
    }
    
    const filter = async () => {
        setFilteredHotels([])
        if (choosenTag !== -1 && choosenName !== ""){

            hotels.forEach((hotel) => {
                if(hotel.tags.map(tag => tag.id).includes(choosenTag) && isSimilar(choosenName, hotel.name)){
                    setFilteredHotels(oldArray => [...oldArray, hotel])
                }
            })

        } else if (choosenTag === -1 && choosenName !== ""){

            hotels.forEach((hotel) => {
                if(isSimilar(choosenName, hotel.name)){
                    setFilteredHotels(oldArray => [...oldArray, hotel])
                }
            })

        } else if (choosenTag !== -1 && choosenName === ""){
            
            hotels.forEach((hotel) => {
                if(hotel.tags.map(tag => tag.id).includes(choosenTag)){
                    setFilteredHotels(oldArray => [...oldArray, hotel])
                }
            })

        }  else {
            setFilteredHotels(hotels)
        }
        setCurrentPage(1)
    }

    return (
        <>
            <ArrowBack to={`/destination2/${categoryId}`} />
            <Container>
                <h2>O que posso encontrar em <br />{destinations.name}</h2>
                <img src={photoURL} alt={destinations.name} />
                
                <div className='center'>
                    <p>{destinations.description}</p>
                </div>
            </Container>
            <ContainerFilter>
                <h2>Busque Hotéis {displayCategory(categoryName)} em {destinations.name}
                </h2>
                <p>Escolha um dos nossos <b>hotéis parceiros</b> e faça umas solicitação de reserva.</p>
                <div className="div-wrapper-search-destination2">
                    <div className="div-search-filter">
                        <div className="div-search-destination">
                            <label>Pesquisar por Nome</label>
                            <Input placeholder="Buscar hotel" type='text' onChange={handleNameChange}/>
                        </div>
                        <div className="div-filter-destination">
                            <label>Comodidades</label>
                            <StyledSelect id='select-state' className="style-select-destination" placeholder="Comodidades" options={tags} onChange={handleTagChange}/>
                        </div>
                    </div>
                    <div className="btn-destination2">
                        <Button format="submit" onClick={filter}>Filtrar Hotéis</Button>
                    </div>
                </div>
                <div className='grid'>
                    {filteredHotels.length > 0? 
                    filteredHotels.slice((currentPage - 1)*pageSize, Math.min(filteredHotels.length, currentPage*pageSize)).map((hotel) => (
                        <Link to={`/destination4/${hotel.id}` }>
                            <CarouselItem
                                key={hotel.id}
                                city= {hotel.name}
                                state = {hotel.category.name}
                                image={hotel.images_url ? `${photo.defaults.baseURL + hotel.images_url}` : '' }
                            />
                        </Link>
                    ))
                    :
                    <div className='not-found'>
                        <p className='main-text'>Nenhum hotel encontrado!</p>
                        <p className='sub-text'>Tente novamente com outros parâmetros de busca</p>
                    </div>
                    }
                </div>
                < div className = 'pagination-box'>
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={filteredHotels.length}
                    pageSize={pageSize}
                    onPageChange={page => setCurrentPage(page)}
                />
                </div>
            </ContainerFilter>
        </>
    );
}

export default Destination3;